module.exports = __webpack_public_path__ + "img/4.b0f0fcb1.webp";